import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import 'rxjs/add/observable/empty'
import { TimestampTypes } from './timestampRedux'
import { LayerTypes } from './layerRedux'

const TIMESTAMP_UPDATE_FULFILLED = TimestampTypes.TIMESTAMP_UPDATE_FULFILLED
const LAYER_TIME_UPDATED = LayerTypes.LAYER_TIME_UPDATED

const layerTimeUpdated = (layerName, timestamp) => {

  return {
  type: LAYER_TIME_UPDATED,
  layerName,
    timestamp
  }
}

const emptyAction = () => ({
  type: 'EMPTY'
})

export const updateLayerEpic = (action$, store) =>
  action$
    .ofType(TIMESTAMP_UPDATE_FULFILLED)
  .map(({ layerName }) => {
    const state = store.getState()
    const time = state.layer.times[layerName]
    const timestamps = state.timestamp.timestamps[layerName]
    if (!timestamps) {
      return emptyAction()
    }
    const timeIncluded = timestamps.find(timestamp => time === new Date(timestamp).getTime())
    const latestTimestamp = new Date(timestamps[timestamps.length - 1]).getTime()
    const action = timeIncluded ? emptyAction() : layerTimeUpdated(layerName, latestTimestamp)
    
    return action
    })
  .catch(error => {
    console.log(error)
    return { type: 'ERROR' }
  })



// WEBPACK FOOTER //
// ./src/redux/layerEpic.js